import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import styled from 'styled-components';
import { DownArrow, UpArrow, DoubleArrow } from 'ui/icons';
import { colors, spacing } from 'ui/theme';
import { useListReferencesContext } from '../../../../contexts/listReferences';
import { SORTABLE_TABLE_COLUMNS_TO_PROPERTIES, TABLE_COLUMNS } from '../constants';
import { Cell } from './Cell';

const SortIconPlaceholder = styled(DoubleArrow).attrs({ 'data-test': 'sort-icon-placeholder' })`
  color: ${colors.textSecondary};
`;

type HeaderCellProps = {
  columnId: TABLE_COLUMNS;
  label: string;
};

const HeaderWrapper = styled(Cell)<{
  columnId: string;
  isBeingSorted: boolean;
}>`
  && {
    background: none;
    border: none;
    outline: none;
    white-space: nowrap;
    border-width: 0 0 ${spacing.single} 0;
    border-style: solid;
    border-color: #d6d6d6;
    span {
      display: inline-block;
      margin-right: ${spacing.quarter};
    }
    text-align: left;
    color: ${({ isBeingSorted }) => (isBeingSorted ? colors.purple100 : colors.textPrimary)};
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
  }
`;

export const testIds = {
  columnHeader: 'segmentation-lrthc-column-header',
};

export const HeaderCell = ({ columnId, label }: HeaderCellProps) => {
  const { sortBy, sortDirection, setSortBy, setSortDirection } = useListReferencesContext();
  const isSortable = columnId in SORTABLE_TABLE_COLUMNS_TO_PROPERTIES;
  const isBeingSorted = sortBy === columnId;
  const SortDirectionIcon = sortDirection === SORT_DIRECTIONS.ASCENDING ? UpArrow : DownArrow;
  const SortIcon = isBeingSorted ? SortDirectionIcon : SortIconPlaceholder;
  const onClick = () => {
    if (isSortable) {
      const toggledSortDirection =
        sortDirection === SORT_DIRECTIONS.ASCENDING
          ? SORT_DIRECTIONS.DESCENDING
          : SORT_DIRECTIONS.ASCENDING;
      setSortBy(columnId);
      setSortDirection(isBeingSorted ? toggledSortDirection : SORT_DIRECTIONS.ASCENDING);
    }
  };

  return (
    <HeaderWrapper
      isBeingSorted={isBeingSorted}
      as={isSortable ? 'button' : 'div'}
      data-test={`${testIds.columnHeader}-${columnId}`}
      columnId={columnId}
      key={columnId}
      onClick={onClick}
    >
      <span>{label}</span>
      {isSortable && <SortIcon isColorInherited />}
    </HeaderWrapper>
  );
};
